import {
  createRootRoute,
  createRoute,
  createRouter,
  Outlet,
  redirect,
} from "@tanstack/react-router";

import { ConsentPage } from "./routes/consent";
import { LoginPage } from "./routes/login";
import { SettingsPage } from "./routes/settings";

// Every page is wrapped in the same card shell the server-rendered pages used.
const rootRoute = createRootRoute({
  component: () => (
    <div className="card">
      <Outlet />
    </div>
  ),
});

// A bare visit lands on the settings screen; it bounces to /login itself if the
// session check comes back 401.
const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/",
  beforeLoad: () => {
    throw redirect({ to: "/settings" });
  },
});

const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/login",
  component: LoginPage,
});

const consentRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/oauth/consent",
  component: ConsentPage,
});

const settingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/settings",
  component: SettingsPage,
});

const routeTree = rootRoute.addChildren([
  indexRoute,
  loginRoute,
  consentRoute,
  settingsRoute,
]);

export const router = createRouter({ routeTree });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
